import SmoothScroll from "./libs/smooth-scroll";

import inView from "./libs/in-view";

import "./libs/jquery/jquery.lazyloadxt.extra";
import "./libs/jquery/jquery.lazyloadxt.bg";
import OwnSlider from "./libs/jquery/jquery.ownSimpleSlider";

import "./libs/bootstrap/collapse";
import "./libs/bootstrap/tooltip";
import "./libs/bootstrap/dropdown";
import "./libs/bootstrap/modal";

import dateFormat from "./libs/dateFormat";
import Chartist from "./libs/chart/Chartist";

import './libs/own-modules/authorization';



try {
    //Pre init preparing
    if (navigator.appVersion.indexOf("Win")!=-1)
    {
        $('body').css('font-family','Arial');
    }
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
        $('video').remove()
    }
} catch (err) {};

if($('video').length){
    $(document).on('lazyshow', 'video', function (e, $el) {
        document.querySelector('video').playbackRate = 0.6;
    });
}

new SmoothScroll('a[href*="#"]', {offset: 70});

inView.offset({top: 150});
let selectedContainer = 'features';
const scroll_block_selectors = ['features', 'technologies', 'affilate', 'advantages', 'press', 'faq', 'competition', 'news', 'contacts'];
scroll_block_selectors.forEach((block) => {
    const selector = "#" + block;

    if($(selector).length){
        inView(selector, {top: 100}).on('enter', (item) => {
            if (item && item !== selectedContainer) {
                selectedContainer = $(item).attr("id");
                $('.nav-item').removeClass('active');
                $('.nav-link[href="#' + selectedContainer + '"]').parent().addClass('active')
            }
        });
    }
});

const intro = $('#intro'),
    introPseudoBlock = $("#pseudo-for-intro-view");
inView('#pseudo-for-intro-view')
    .on("enter", (el) => {
        intro.removeClass('scrolling');
    })
    .on("exit", (el) => {
        intro.addClass('scrolling')
    });

const navbar = $('#navbar'),
    nav_wrap = $(".nav-wrap");

inView('#intro')
    .on("enter", (el) => {
        navbar.removeClass('navbar-light').addClass('navbar-dark').removeClass('bg-light');
        nav_wrap.removeClass('navbar-light').addClass('navbar-dark');
    })
    .on("exit", (el) => {
        navbar.removeClass('navbar-dark').addClass('navbar-light').addClass('bg-light');
        nav_wrap.removeClass('navbar-dark').addClass('navbar-light');
    });

$('[data-toggle="tooltip"]').tooltip();
$('[data-toggle="dropdown"]').dropdown();


const orbits_arr = $('.orbita_sattelite');
if (orbits_arr.length) {
// start orbits graph initialization
$(orbits_arr[0]).addClass('active');
setInterval(function() {
    const max = orbits_arr.length -1,
        random = Math.floor(Math.random() * max),
        random2 = Math.floor(Math.random() * max);

    $(orbits_arr).removeClass('active');
    $(orbits_arr[random]).addClass('active');
    $(orbits_arr[random2]).addClass('active');

} , 5000);
// end orbits graph initialization
}

const advantages_media = $('.advantages-media');
if (advantages_media.length) {
// start advantages-media chart initialization
const today = new Date(),
    tomorrow =  new Date(),
    chartLabels = window.series[0].map(function(value, key) {
        const quarters = [1,2,3,4];
        if (!key) {
            return dateFormat(today,"yyyy-mm-dd h:MM")
        } else {
            tomorrow.setDate(today.getDate() + 180);
            const month = Math.floor(tomorrow.getMonth() / 3),
                quarter = quarters[month];
            return dateFormat(tomorrow,"yyyy-Q"+quarter)
        }
    });


const chart = new Chartist.Line('.advantages-media', {
        labels: chartLabels,
        series: window.series
    }, {
        low: 0,
        fullWidth: true,
        showArea: true,
        height: 400,
        axisY: {
            position: 'end',
        }
    });

const initChartTooltip = () => {
    const points = $('.ct-point');

    window.series[0].map(function (value, key) {
        const point = $(points.get(key));

        point.attr('data-html','true')
            .attr('data-offset','0, 20px')
            .attr('data-placement','top')
            .attr('title','<h4 class="mb-2">'+chartLabels[key]+' your portfolio</h4><h5>'+value+' BTC</h5>')
            .tooltip('update')
    });

    $('.ct-point').mouseover(() => {
        $('.ct-point-active').removeClass('ct-point-active').tooltip('hide')
    })
};

chart.on("created", () => {
    initChartTooltip();
});

window.onresize = function(event) {
    $('.ct-point').tooltip('dispose');
};
// end advantages-media chart initialization
}

$(document).ready(function () {
    const mobMaxViewportWidth = 568;

    if(window.pageYOffset > introPseudoBlock.height()){
        intro.addClass('scrolling')
    }

    if(window.pageYOffset > intro.height()){
        navbar.removeClass('navbar-dark').addClass('navbar-light').addClass('bg-light');
        nav_wrap.removeClass('navbar-dark').addClass('navbar-light');
    }

    const slider = new OwnSlider({
        element: $(".slider-on-mobile.slide-advantages"),
        arrows: false
    });

    if(window.innerWidth >= mobMaxViewportWidth){
        slider.destroy();
    }

    $(window).on("resize", () => {

        if(window.innerWidth >= mobMaxViewportWidth && slider.enabled){
            slider.destroy();
            slider.enabled = false;
        }else if(window.innerWidth < mobMaxViewportWidth && !slider.enabled){
            slider.init();
        }
    });

    const advantages_table = $(".mob-only-one-col");
    $('.mob-only-one-col thead th').on("click", function () {
        const item = $(this);
        advantages_table.removeClass((index, className) => {
            return (className.match(/column-\S+/g) || []).join(" ");
        }).addClass(() => {
            return "column-" + (item.attr('data-col-index') ? item.attr('data-col-index') : "0");
        })
    });

    const nav_bar = $(".navbar-collapse"),
        $body = $("body");
    nav_bar
        .on("hide.bs.collapse", () => {
            $body.removeClass("mob-no-scroll");
        })
        .on("shown.bs.collapse", () => {
            $body.addClass("mob-no-scroll");
        });


    const password_view_switcher = $(".toggle-password-view");
    password_view_switcher.on("click", (e) => {
        let $this = $(e.target),
            $input = $this.closest(".form-group").find('.checkpass'),
            is_type_text = $input.attr("type") === "text";

        is_type_text ? $input.attr("type", "password") : $input.attr("type", "text");
        is_type_text ? $this.removeClass("shown").addClass("hidden-pass") : $this.removeClass("hidden-pass").addClass("shown");
    });

});